import { LoadingStrategy } from './ResourceLoader';

export class HttpLoadingStrategy implements LoadingStrategy {
  constructor(private baseUrl: string = '') {}

  load(resourceLocation: string): Promise<Uint8Array> {
    const url = /^[a-z]+:\/\//i.test(resourceLocation)
      ? resourceLocation
      : this.baseUrl + resourceLocation;

    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'arraybuffer';

      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(new Uint8Array(xhr.response));
        } else {
          reject(new Error(`${url} returned status code ${xhr.status}`));
        }
      };
      xhr.onerror = () => reject(new Error(`${url} network error`));

      xhr.send();
    });
  }
}
